import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { Errors } from '../style';
import { MultiTableComponentProps } from '../types';
import { idCreator } from '../../../../../Project/utils/idCreator';

const columnLables = {
  assumption_details: {
    name: 'Assumption Details'
  },
  fca_field_reference: {
    name: 'FCA Field Reference'
  }
};

export function AssumptionsAIF001({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.ASSUMPTIONS001,
    onChangeFund,
    schema: schema.ASSUMPTIONS001,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.ASSUMPTIONS001?.field_names || [],
    isMultiFunds,
    funds,
    onAddColumn,
    onDeleteColumn,
    columnLables,
    tableName: 'ASSUMPTIONS001',
    order: 37 as any
  });

  const isRequiredTable =
    funds[currentDataKey]?.required_tables?.ASSUMPTIONS001?.field_names?.length === 0;

  const errors = funds[currentDataKey]?.fund_data?.ASSUMPTIONS001?.find(
    item => item?.errors?.general
  )?.errors?.general as any;

  return (
    <>
      <Errors id="fca-reporttables-assumptions-aif001-errors">
        {isRequiredTable && (
          <li id="fca-reporttables-assumptions-aif001-required-error">
            This section must be completed
          </li>
        )}
        {errors?.map(item => (
          <li
            key={item.msg}
            id={`fca-reporttables-assumptions-aif001-error-${idCreator(item.msg)}`}
          >
            {item.msg}
          </li>
        ))}
      </Errors>

      <Table
        id="fca-reporttables-assumptions-aif001-table"
        handleChanges={onChange}
        columns={columns}
        rows={rows}
        stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      />
    </>
  );
}
